<template>
    <div>
        <M3TopBar v-if="header" :data="header"></M3TopBar>
        <div v-if="data && data2 && termeneV3" class="padding-box" style="padding-bottom: 145px;">
            <div class="flex space-between align-items-center mb-3 mt-0">
                <h1 class="m-0 raport-result">Compania ta
                    <span v-if="body.eligibilitate" class="bolder" >este eligibilă*</span>
                    <span v-else class="bolder">nu este eligibilă*</span>
                    pentru o finanțare nerambursabilă de până la <span class="bolder">{{ finantareMaxim.toLocaleString('ro-RO') }} €</span>
                </h1>
                <div class="buttons upper-btns flex space-between">
                    <div class="write-button" :class="disabled ? 'disabled' : ''" @click="addM3Company()"><span v-if="!scrieLoading">Scrie proiect</span><span v-else style="min-width: 80px; text-align: center; max-height: 20px;"><b-spinner style="max-height: 18px; max-width: 18px;"></b-spinner></span></div>
                    <div class="red-button" @click="openConsultantModal()"><span>Caută un consultant</span></div>
                    <div class="back-button" @click="$emit('backCuiInput')"><span>Verifică altă firmă</span></div>
                </div>
            </div>
            <div class="white-box flex space-between">
                <p>
                    <img src="@/assets/images/M3/smisSmall.png" alt="SMIS" class="smallLogo"> în parteneriat cu <a href="https://termene.ro/" target="_blank"><img src="@/assets/images/M3/termeneSmall.png" class="smallLogo"></a> îți prezintă în
                    exclusivitate raportul privind compania ta în vederea obținerii unei finanțări nerambursabile de până la 1.000.000 €
                    prin Programul Operațional Competitivitate 2014-2020 - Axa Prioritara 4.
                </p>
                <img src="@/assets/images/M3/poc-status.png" alt="POC Status" class="m3-small">
            </div>

            <div class="flex space-between columnLg">
                <div style="width: 70%;">
                    <M3StatusStatistici
						:hasNegativeCapital="dateModal && dateModal.capital2019 ? dateModal.capital2019 < 0 : ''"
						:data="data"
						:data2="data2"
						:termeneV3="termeneV3"
						:eligibilitate="body.eligibilitate"
						:ca-percent="caPercent"
						@addM3Company="addM3Company"
						@MaxFinancing="finantareMaxim = $event"
						@eligibleCompany="eligibleCompany()"
						@notEligibleImm="body.eligibilitate = false;
						data2.isEligible = false"
						@cofinanceValue="setCofinance($event)">
					</M3StatusStatistici>
                    <div class="green-bar mt-3" @click="addM3Company">
                        <h2>Scrie proiectul tău de investiții utilizând aplicația completă <strong>411 POC</strong>Sketch®</h2>
                        <img src="@/assets/images/sketch_new.png" alt="POC Sketch">
                    </div>
                </div>
                <div class="ajutoare-stat white-box mt-3">
                    <span class="background-title">Informații cu privire la alte ajutoare de stat solicitate</span>
                    <div class="masura">
                        <p class="masura-title">MĂSURA 1</p>
                        <p class="masura-desc">Microgranturi acordate din fonduri externe nerambursabile</p>
                        <div class="flex items-center masura-bani">
                            <b-icon-check-circle-fill v-if="help_moneyM1 && help_moneyM1 > 0" font-scale="1.2" class="eligibil mr-2"></b-icon-check-circle-fill>
                            <b-icon-x-circle-fill v-else font-scale="1.2" class="neeligibil mr-2"></b-icon-x-circle-fill>
                            <span v-if="help_moneyM1 && help_moneyM1 > 0" class="green-text">Compania a aplicat la ajutor de stat prin Măsura 1</span>
                            <span v-else class="red-text">Compania nu a solicitat ajutor</span>
                        </div>
                        <p v-if="help_moneyM1 && help_moneyM1 > 0" class="bani-primiti green-text">
                            <span>L {{ help_moneyM1 }} &nbsp;&nbsp; <strong>€ {{ (help_moneyM1 / 4.8395).toFixed(2) }}</strong></span>
                        </p>
                    </div>
                    <div class="masura">
                        <p class="masura-title">MĂSURA 2</p>
                        <p class="masura-desc">Granturi pentru capital de lucru acordate IMM-urilor</p>
                        <div class="flex items-center masura-bani">
                            <b-icon-check-circle-fill v-if="help_moneyM2 && help_moneyM2 > 0" font-scale="1.2" class="eligibil mr-2"></b-icon-check-circle-fill>
                            <b-icon-x-circle-fill v-else font-scale="1.2" class="neeligibil mr-2"></b-icon-x-circle-fill>
                            <span v-if="help_moneyM2 && help_moneyM2 > 0" class="green-text">Compania a aplicat la ajutor de stat prin Măsura 2</span>
                            <span v-else class="red-text">Compania nu a solicitat ajutor</span>
                        </div>
                        <p v-if="help_moneyM2 && help_moneyM2 > 0" class="bani-primiti green-text">
                            <span>L {{ help_moneyM2 }} &nbsp;&nbsp; <strong>€ {{ (help_moneyM2 / 4.8395).toFixed(2) }}</strong></span>
                        </p>
                    </div>
                    <div class="masura">
                        <p class="masura-title">HORECA</p>
                        <p class="masura-desc">Sprijin financiar pentru întreprinderile din domeniul HORECA</p>
                        <div class="flex items-center masura-bani">
                            <b-icon-check-circle-fill v-if="help_moneyHoreca && help_moneyHoreca > 0" font-scale="1.2" class="eligibil mr-2"></b-icon-check-circle-fill>
                            <b-icon-x-circle-fill v-else font-scale="1.2" class="neeligibil mr-2"></b-icon-x-circle-fill>
                            <span v-if="help_moneyHoreca && help_moneyHoreca > 0" class="green-text">Compania a aplicat la ajutor de stat prin Horeca</span>
                            <span v-else class="red-text">Compania nu a solicitat ajutor</span>
                        </div>
                        <p v-if="help_moneyHoreca && help_moneyHoreca > 0" class="bani-primiti green-text">
                            <span>L {{ help_moneyHoreca }} &nbsp;&nbsp; <strong>€ {{ (help_moneyHoreca / 4.9260).toFixed(2) }}</strong></span>
                        </p>
                    </div>
                    <div class="masura">
                        <p class="masura-title">IMM INVEST</p>
                        <p class="masura-desc">Ajutor de stat prin FNGCIMM</p>
                        <div class="flex items-center masura-bani">
                            <b-icon-info-circle-fill v-if="data.imminvest && data.imminvest.length > 0" font-scale="1.2" class="infoPoint mr-2"></b-icon-info-circle-fill>
                            <b-icon-x-circle-fill v-else font-scale="1.2" class="neeligibil mr-2"></b-icon-x-circle-fill>
                            <span v-if="data.imminvest && data.imminvest.length > 0" class="infoPoint">Compania a solicitat ajutor: STATUS - {{ data.imminvest[0].stare_solicitare }}</span>
                            <span v-else class="red-text">Compania nu a solicitat ajutor</span>
                        </div>
                    </div>
                    <span style="font-size: 11px; display: block; color: rgb(177, 179, 191); margin-top: 15px;">Beneficiarul ajutorului de stat poate accesa şi alte scheme de ajutor de stat elaborate în baza Comunicării Comisiei - Cadru temporar pentru măsuri de ajutor de stat de sprijinire a economiei în contextul actualei epidemii de COVID-19 (2020/C91I/01), în limita plafonului echivalent în lei al sumei de 1.800.000 euro</span>
                    <div class="calcule-ajutoare">
                        <div class="suma-ajutor green-text">
                            <p class="total-title">Total solicitat:</p>
                            <p class="total-suma" style="font-size: 19px;"><strong>{{ Number(checkMaxAids()).toFixed(0) }} €</strong></p>
                        </div>
                        <div class="suma-ajutor green-text">
                            <p class="total-title">Total disponibil:</p>
                            <p class="total-suma" style="font-size: 19px;"><strong>{{ (1800000 - checkMaxAids()).toFixed(0) }} €</strong></p>
                        </div>
                        <div class="suma-ajutor green-text">
                            <p class="total-title">Maxim POC 411:</p>
                            <p class="total-suma" style="font-size: 19px; display: flex; align-items: center;">
                                <b-icon-check-circle-fill font-scale="0.8" class="eligibil mr-2"></b-icon-check-circle-fill>
                                <strong>{{ finantareMaxim }} €</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex space-between mt-3">
                <div class="proiectulTau white-box">
                    <span class="background-title">Proiectul tău</span>
                    <div class="space-between proiectulTauCharts">
                        <div class="first-box">
                            <span class="proiectulTauTitle">Punctaj maxim</span>
                            <span>&nbsp;</span>
                            <apexchart v-if="body && body.punctaj" type="radialBar" height="180" :options="chartOptions" :series="[body.punctaj]"></apexchart>
                        </div>
                        <div class="second-box">
                            <span class="proiectulTauTitle">Procent cofinanțare</span>
                            <span style="color: #7a7e93">(informativ)</span>
                            <apexchart v-if="body && body.cofinantare !== null" type="radialBar" height="180" :options="chartOptions2" :series="[body.cofinantare === 0 ? 5 : body.cofinantare]"></apexchart>
                        </div>
                    </div>
                    <M3CheltuieliEligibile></M3CheltuieliEligibile>
                </div>
                <div class="punctaj">
                    <div class="white-box h-100">
                        <M3StatusPunctaj :data="body" @addM3Company="addM3Company" @openConsultantModal="openConsultantModal" @scoreCalculated="calculateTotalScore($event)"></M3StatusPunctaj>
                    </div>
                </div>
                <div class="caen-principal white-box">
                    <span class="background-title">CAEN principal</span>
                    <p :class="caenEligibil(true)" class="caen">{{ data.codCaenPrincipalRecom[0].cod_caen }}</p>
                    <span class="background-title">CAEN secundare eligibile</span>
                    <ul>
                        <li
                            v-for="(caenSecundar, key) in secCaenEligibil()"
                            :key="key"
                            class="caen-small"
                        >
                            <span :class="caenSecundar.eligibil !== 'pozitiv' ? 'eligibil' : ''">
                                {{ caenSecundar.caen }}
                            </span>
                        </li>
                    </ul>
                    <div class="flex">
                        <div class="flex caen-status">
                            <div class="bullet-bg-green mr-2">
                                <div class="bullet"></div>
                            </div>
                            <span>CAEN eligibil - sold negativ</span>
                        </div>
                        <div class="flex caen-status" style="margin-left: 10px;">
                            <div class="bullet-bg-blue mr-2">
                                <div class="bullet"></div>
                            </div>
                            <span>CAEN eligibil - sold pozitiv</span>
                        </div>
                        <div class="flex caen-status" style="margin-left: 10px;">
                            <div class="bullet-bg-red mr-2">
                                <div class="bullet"></div>
                            </div>
                            <span>CAEN neeligibil</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex space-between mt-3">
                <div class="informatii-utile white-box">
                    <span class="background-title">Informații utile</span>
                    <div class="infoUtile">
                        <div class="infoContainer-outer" style="margin-right: 10px;">
                            <div class="infoContainer">
                                <img src="@/assets/images/logoguvern.png" alt="Logo Guvern">
                                <a href="https://granturi.imm.gov.ro/" target="_blank" class="infoLinks govLinks" style="width: 45%">Creează cont în IMM Recover</a>
                                <a href="https://mfe.gov.ro/" target="_blank" class="infoLinks govLinks" style="width: 35%">Vizitează mfe.gov.ro</a>
                            </div>
                            <div style="padding-left: 10px;">
                                <span class="infoDescription">Apelul de proiecte pentru “Investiții în activități productive” este unul competitiv, cu depunere continuă până la data închiderii apelulului. Cererile de finanţare se vor depune prin platforma IMM Recover, cu toate anexele solicitate prin Ghidul Solicitantului.</span>
                            </div>
                        </div>
                        <div class="infoContainer-outer" style="margin-right: 10px;">
                            <div class="infoContainer">
                                <img src="@/assets/images/smis_logo_color.png" alt="Smis logo">
                                <a href="https://smis.ro/finantari/poc411" target="_blank" class="infoLinks smisLinks" style="width: 45%">Vezi prezentarea completă</a>
                                <a href="https://mfe.gov.ro/poc-ghidul-consolidat-aferent-actiunii-4-1-1-investitii-in-activitati-productive/" target="_blank" class="infoLinks smisLinks" style="width: 35%">Descarcă ghidul</a>
                                <!-- https://smis.ro/documents/Ghid_4.1.1_DRAFT_noiembrie_2021_MO.pdf -->
                            </div>
                            <div style="padding-left: 10px;">
                                <span class="infoDescription">Echipa Smis® a analizat cu atenție ghidul solicitantului și a conturat un ghid de aplicare și scriere simplificat. Îți mulțumim!</span>
                            </div>
                        </div>
                        <div class="infoContainer-outer">
                            <div class="infoContainer">
                                <div><img src="@/assets/images/sketch_new.png" alt="POC Sketch" ></div>
                                <span class="infoLinks smisLinks" style="width: 35%" @click="addM3Company()">Scrie proiectul tău</span>
                            </div>
                            <div style="padding-left: 10px;">
                                <span class="infoDescription">Echipa Smis® a dezvoltat o super aplicație în scrierea proiectului. Începe acum să scrii gratuit proiectul tău.</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="body && dateModal" class="mt-5">
                        <span class="background-title">Informații companie</span>
                        <p class="analiza-title mt-3">Cifra de afaceri 2019: <span class="analiza-number">{{ body.cf2019 }} lei</span></p>
                        <p class="analiza-title mt-2">Cifra de afaceri 2020: <span class="analiza-number">{{ body.cf2020 }} lei</span></p>
                        <p class="analiza-title mt-2">
                            Eligibilitate:
                            <span class="analiza-number">
                                <span v-if="body.eligibilitate" style="color: #36ad8c;">Firmă eligibilă</span>
                                <span v-else style="color: #ff6767;">Firmă neeligibilă</span>
                            </span>
                        </p>
                        <p class="analiza-title mt-2">Angajați 2019: <span class="analiza-number">{{ dateModal && dateModal.angajati2019 ? dateModal.angajati2019 : 0 }}</span></p>
                        <p class="analiza-title mt-2">Angajați 2020: <span class="analiza-number">{{ dateModal && dateModal.angajati2020 ? dateModal.angajati2020 : 0 }}</span></p>
                        <p class="analiza-title mt-2">Capital 2019: <span class="analiza-number">{{ dateModal.capital2019 }}</span></p>
                        <p class="analiza-title mt-2">Capital 2020: <span class="analiza-number">{{ dateModal.capital2020 }}</span></p>
                        <p class="analiza-title mt-2">Statut TVA: <span class="analiza-number">{{ dateModal.statutTVA }}</span></p>
                    </div>
                </div>

                <div :class="body.eligibilitate ? 'interogari-eligibil' : 'interogari-neeligibil'" class="interogari white-box">
                    <h2>{{ interogariNoi }}</h2>
                    <p style="font-size:14px; font-weight:500;color:#d1d1d1;">Interogări începând cu 21 februarie (ghid consolidat)</p>

                    <M3StatisticiCharts v-if="statistici" :data="statistici"></M3StatisticiCharts>

                    <h2>{{ interogari }}</h2>
                    <p><b>Total interogări</b> - inclusiv în perioada ghidului consultativ</p>
                    <!-- <p class="mt-3">Valoarea minimă a proiectului: <strong>50.000 €</strong></p>
                    <p>Valoarea maximă a proiectului: <strong>1.000.000 €</strong></p>
                    <p class="mb-3">Bugetul total al apelului: <strong>358.300.000 €</strong></p> -->

                    <a href="https://termene.ro/" target="_blank"><img src="@/assets/images/logo-termene.png" style="width: 170px" class="mt-3 termene-logo" alt="Termene"></a>
                </div>
            </div>


            <!--            <div class="grid-m3 mt-3">-->
            <!--                <div class="detalii-finantare">-->
            <!--                    <div class="white-box h-100">-->
            <!--                        <span class="module-title">Detalii despre finanțarea nerambursabilă</span>-->
            <!--                        <p class="mt-3"><strong>Acțiunea 4.1.1</strong></p>-->
            <!--                        <p class="m-0">Investiții în activități productive</p>-->
            <!--                        <p class="mt-3">Consolidarea poziției pe piață a IMM-urilor afectate de pandemia COVID-19 - Programul Operațional Competitivitate 2014-2020 - Axa Prioritara 4 </p>-->
            <!--                        <p class="mt-3">Valoarea maximă a proiectului: <strong>1.000.000 €</strong></p>-->
            <!--                        <p class="mb-3">Bugetul total al apelului: <strong>358.300.000 €</strong></p>-->
            <!--                        <span class="module-title">TIPURI DE ACTIVITĂȚI ELIGIBILE & VALOAREA COFINANȚĂRII</span>-->
            <!--                        <p class="mt-3">-->
            <!--                            Construirea/achiziția /extinderea spațiilor de producție/servicii – maxim 50% din valoarea proiectului;-->
            <!--                            Dotarea cu active corporale, necorporale.-->
            <!--                        </p>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="dataghid flex flex-column space-between">-->
            <!--                    <div class="white-box">-->
            <!--                        <p class="m-0">Data deschiderii apelului de proiecte: <strong class="green">în curs de lansare</strong></p>-->
            <!--                    </div>-->
            <!--                    <div class="white-box flex space-between fixed-height">-->
            <!--                        <div class="flex flex-column align-center paddingleft">-->
            <!--                            <p class="m-0 mb-2"><strong>Descarcă ghid</strong></p>-->
            <!--                            <a href="https://smis.ro/GS_Masura3.pdf" target="_blank">-->
            <!--                                <img src="@/assets/images/M3/descarca-ghid.png">-->
            <!--                            </a>-->
            <!--                        </div>-->
            <!--                        <div class="flex flex-column align-center paddingright">-->
            <!--                            <p class="m-0 mb-2"><strong>Depune proiect</strong></p>-->
            <!--                            <a href="https://2014.mysmis.ro/" target="_blank">-->
            <!--                                <img src="@/assets/images/M3/mysmis.png">-->
            <!--                            </a>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="cheltuieli-eligibile flex space-between">-->
            <!--                    <div class="blue-box h-100">-->
            <!--                        <a href="https://termene.ro/" target="_blank">-->
            <!--                            <img src="@/assets/images/M3/termenealb.png">-->
            <!--                        </a>-->
            <!--                    </div>-->
            <!--                    <M3CheltuieliEligibile class="cheltuieli-box" :data="body.cofinantare"></M3CheltuieliEligibile>-->
            <!--                </div>-->
            <!--                <div class="incepe-gratuit">-->
            <!--                    <div class="green-button">-->
            <!--                        &lt;!&ndash;<div :class="disabled ? 'disabled' : ''" @click="workingAt()">&ndash;&gt;-->
            <!--                        <div @click="addM3Company()">-->
            <!--                            <span>Începe să scrii <span class="yellow">GRATUIT</span> proiectul tău pentru Investiții</span>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="firma-consultanta flex space-between">-->
            <!--                    <div class="white-box item-a">-->
            <!--                        <img src="@/assets/images/M3/poc_sketch.png">-->
            <!--                    </div>-->
            <!--                    <div class="white-box item-b">-->
            <!--                        <a href="https://masura3.ro/cauta-consultant" target="_blank">-->
            <!--                            <p class="m-0">Vreau să apelez la<br>un <strong>consultant</strong></p>-->
            <!--                        </a>-->
            <!--                    </div>-->
            <!--                    <div class="orange-button item-c">-->
            <!--                        <div @click="openCompanyModal()">-->
            <!--                            <span>Reprezint o <strong>firmă de consultanță</strong>.<br>Doresc să utilizez aplicația <strong>POC</strong>Sketch® pentru un număr mare de beneficiari.</span>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <div v-if="data2.isEligible" :class="modalShow ? 'not-showing' : 'showing'" class="modal-bottom" @click="modalShow = true; consultantShowModal = false">
                <img src="@/assets/images/M3/M3Sketch/poc_sketch_wide.png" alt="POC Sketch" class="sketch-logo info-sketch">
                <div class="flex info-sketch align-items-center">
                    <span class="number">{{ dateModal && dateModal.companii ? dateModal.companii : 0 }}</span>
                    <p>proiecte în curs de scriere acum</p>
                </div>
                <a href="https://www.youtube.com/watch?v=iLZzc_KfvcE&t=1s&ab_channel=SMISRomania" target="_blank"
                   class="flex info-sketch align-items-center"
                >
                    <img src="@/assets/images/M3/M3Sketch/play-gradient.png" alt="M3Sketch">
                    <p>vezi prezentarea video a funcțiilor aplicației</p>
                </a>
                <div class="flex space-between buttons">
                    <div class="button-purple" @click.stop="addM3Company()">Scrie proiectul tău</div>
                    <div class="white-border-button consultant-button" @click.stop="openConsultantModal()">Caută un consultant</div>
                </div>
            </div>
        </div>
        <LoadingSpinner v-else class="loadingSpinner"></LoadingSpinner>
        <M3ScriePopup
            :scriePopup="modalShow"
            :dataStatus="dateModal"
            :consultantShow="consultantShowModal"
            :eligible="body.eligibilitate"
            :max-financing="finantareMaxim"
            :cofinantare="cofinantare"
            @hideTempModal="modalShow = false"
            @backCuiInput="$emit('backCuiInput')"
            @addM3Company="addM3Company()"
        >
        </M3ScriePopup>
        <M3NeeligibilPopup
            :neeligibilPopup="modalNeeligibil"
            :dateFirma="dateNeeligibila"
            @hideTempModal="modalNeeligibil = false"
            @submitCompany="submitNeeligibleCompany($event)"
        >
        </M3NeeligibilPopup>
        <CompanyModal
            :companyModal="companyModal"
            @hideTempModal="companyModal = false"
        ></CompanyModal>
    </div>
</template>

<script>
    import M3TopBar from './M3TopBar'
    import M3StatusPunctaj from './components/M3StatusPunctaj'
    import M3CheltuieliEligibile from './components/M3CheltuieliEligibile'
    import M3StatusStatistici from './components/M3StatusStatistici'
    import M3ScriePopup from './components/M3ScriePopup'
    import M3NeeligibilPopup from './components/M3NeeligibilPopup'
    import M3StatisticiCharts from "./components/M3StatisticiCharts";
    import CompanyModal from './components/CompanyModal'
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import {BSpinner, BIconXCircleFill, BIconCheckCircleFill, BIconInfoCircleFill} from "bootstrap-vue";
    import listaCaen from '@/pages/Aplicatii/M3/caen_eligibil.json';
    import _ from "lodash";
    import moment from 'moment'

    export default {
        components: {
            LoadingSpinner,
            M3TopBar,
            M3StatusPunctaj,
            M3CheltuieliEligibile,
            M3StatusStatistici,
            M3StatisticiCharts,
            BIconXCircleFill, BIconCheckCircleFill, BIconInfoCircleFill,
            M3ScriePopup,
            M3NeeligibilPopup,
            CompanyModal,
            BSpinner
        },
        props: {
            data: null,
            data2: null,
            termeneV3: null,
        },
        data() {
            return {
                scrieLoading: false,
                cofinantare: 0,
                finantareMaxim: 0,
                header: {
                    caenPrincipal: null,
                    caenSecundare: null,
                    eligibilitate: null,
                    nume: null,
                    caenSecundareEligibile: null,
                },
                body: {
                    eligibilitate: null,
                    criterii: null,
                    punctaj: null,
                    cofinantare: null,
                    cf2019: null,
                    cf2020: null
                },
                interogari: null,
                interogariNoi: null,
                statistici: null,
                disabled: null,
                timeout: null,
                companyInfo: {},
                caenMain: null,
                modalShow: false,
                modalNeeligibil: false,
                dateModal: null,
                consultantShowModal: false,
                companyModal: false,
                help_moneyM1: null,
                help_moneyM2: null,
                help_moneyHoreca: null,
                maxBudget: null,
                series: 0,
                dateNeeligibila: [],
                caPercent: 0,
                letters: [
                    {'base':'A', 'letters':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
                    {'base':'AA','letters':/[\uA732]/g},
                    {'base':'AE','letters':/[\u00C6\u01FC\u01E2]/g},
                    {'base':'AO','letters':/[\uA734]/g},
                    {'base':'AU','letters':/[\uA736]/g},
                    {'base':'AV','letters':/[\uA738\uA73A]/g},
                    {'base':'AY','letters':/[\uA73C]/g},
                    {'base':'B', 'letters':/[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
                    {'base':'C', 'letters':/[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
                    {'base':'D', 'letters':/[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
                    {'base':'DZ','letters':/[\u01F1\u01C4]/g},
                    {'base':'Dz','letters':/[\u01F2\u01C5]/g},
                    {'base':'E', 'letters':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
                    {'base':'F', 'letters':/[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
                    {'base':'G', 'letters':/[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
                    {'base':'H', 'letters':/[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
                    {'base':'I', 'letters':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
                    {'base':'J', 'letters':/[\u004A\u24BF\uFF2A\u0134\u0248]/g},
                    {'base':'K', 'letters':/[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
                    {'base':'L', 'letters':/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
                    {'base':'LJ','letters':/[\u01C7]/g},
                    {'base':'Lj','letters':/[\u01C8]/g},
                    {'base':'M', 'letters':/[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
                    {'base':'N', 'letters':/[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
                    {'base':'NJ','letters':/[\u01CA]/g},
                    {'base':'Nj','letters':/[\u01CB]/g},
                    {'base':'O', 'letters':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
                    {'base':'OI','letters':/[\u01A2]/g},
                    {'base':'OO','letters':/[\uA74E]/g},
                    {'base':'OU','letters':/[\u0222]/g},
                    {'base':'P', 'letters':/[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
                    {'base':'Q', 'letters':/[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
                    {'base':'R', 'letters':/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
                    {'base':'S', 'letters':/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
                    {'base':'T', 'letters':/[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
                    {'base':'TZ','letters':/[\uA728]/g},
                    {'base':'U', 'letters':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
                    {'base':'V', 'letters':/[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
                    {'base':'VY','letters':/[\uA760]/g},
                    {'base':'W', 'letters':/[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
                    {'base':'X', 'letters':/[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
                    {'base':'Y', 'letters':/[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
                    {'base':'Z', 'letters':/[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
                    {'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
                    {'base':'aa','letters':/[\uA733]/g},
                    {'base':'ae','letters':/[\u00E6\u01FD\u01E3]/g},
                    {'base':'ao','letters':/[\uA735]/g},
                    {'base':'au','letters':/[\uA737]/g},
                    {'base':'av','letters':/[\uA739\uA73B]/g},
                    {'base':'ay','letters':/[\uA73D]/g},
                    {'base':'b', 'letters':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
                    {'base':'c', 'letters':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
                    {'base':'d', 'letters':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
                    {'base':'dz','letters':/[\u01F3\u01C6]/g},
                    {'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
                    {'base':'f', 'letters':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
                    {'base':'g', 'letters':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
                    {'base':'h', 'letters':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
                    {'base':'hv','letters':/[\u0195]/g},
                    {'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
                    {'base':'j', 'letters':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
                    {'base':'k', 'letters':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
                    {'base':'l', 'letters':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
                    {'base':'lj','letters':/[\u01C9]/g},
                    {'base':'m', 'letters':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
                    {'base':'n', 'letters':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
                    {'base':'nj','letters':/[\u01CC]/g},
                    {'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
                    {'base':'oi','letters':/[\u01A3]/g},
                    {'base':'ou','letters':/[\u0223]/g},
                    {'base':'oo','letters':/[\uA74F]/g},
                    {'base':'p','letters':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
                    {'base':'q','letters':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
                    {'base':'r','letters':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
                    {'base':'s','letters':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
                    {'base':'t','letters':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
                    {'base':'tz','letters':/[\uA729]/g},
                    {'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
                    {'base':'v','letters':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
                    {'base':'vy','letters':/[\uA761]/g},
                    {'base':'w','letters':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
                    {'base':'x','letters':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
                    {'base':'y','letters':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
                    {'base':'z','letters':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
                ],
                chartOptions: {
                    colors: ['#46cca6'],
                    chart: {
                        height: 180,
                        type: 'radialBar',
                    },
                    plotOptions: {
                        radialBar: {
                            hollow: {
                                size: '60%',
                            },
                            dataLabels: {
                                show: true,
                                name: {
                                    offsetY: -10,
                                    show: false,
                                    color: '#888',
                                    fontSize: '17px'
                                },
                                value: {
                                    formatter: function(val) {
                                        return parseInt(val);
                                    },
                                    color: '#111',
                                    fontSize: '33px',
                                    show: true,
                                }
                            }
                        },
                    },
                    states: {
                        normal: {
                            filter: {
                                type: 'none',
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                        active: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                    labels: ['Puncte'],
                },
                chartOptions2: {
                    colors: ['#46cca6'],
                    chart: {
                        height: 180,
                        type: 'radialBar',
                    },
                    plotOptions: {
                        radialBar: {
                            hollow: {
                                size: '60%',
                            },
                            dataLabels: {
                                show: true,
                                name: {
                                    offsetY: -10,
                                    show: false,
                                    color: '#888',
                                    fontSize: '17px'
                                },
                                value: {
                                    formatter: function(val) {
                                        return parseInt(val)+'%';
                                    },
                                    color: '#111',
                                    fontSize: '33px',
                                    show: true,
                                }
                            }
                        },
                    },
                    states: {
                        normal: {
                            filter: {
                                type: 'none',
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                        active: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                    labels: ['Puncte'],
                },
            }
        },
        computed: {
            stateAids() {
                return this.$store.getters['stateAids/getStateAids']
            }
        },
        watch: {
            termeneV3: {
                handler: function () {
                    this.prepareModalData()
                    this.cofinantare = ((this.data2.cofinancing / 100) * Number(this.finantareMaxim)).toFixed(0)
                },
                deep:true
            },
            data2: {
                handler: function () {
                    this.cofinantare = ((this.data2.cofinancing / 100) * Number(this.finantareMaxim)).toFixed(0)
                },
                deep:true
            },
        },
        mounted() {
            this.checkStateAids();
            if(this.data){
                this.header = {
                    caenPrincipal: this.data.codCaenPrincipalRecom[0].cod_caen,
                    caenSecundare: this.data.coduriCaenSecundare.length,
                    eligibilitate: this.data2.isEligible,
                    nume: this.data2.nume,
                    caenSecundareEligibile: this.data2.eligibleCaens,
                }
                this.body = {
                    eligibilitate: this.data2.isEligible,
                    criterii: this.data2.evaluation.criteria,
                    punctaj: this.data2.evaluation.score,
                    cofinantare: this.data2.cofinancing,
                    cf2019: this.data.CA_2019 ? this.data.CA_2019 : 0,
                    cf2020: this.data.CA_2020 ? this.data.CA_2020 : 0,
                }
                this.dateModal = {
                    companie: this.data2.nume,
                    cui: this.data2.cui,
                    punctaj: this.data2.evaluation.score,
                    caen_principal: this.data.codCaenPrincipalRecom ? this.data.codCaenPrincipalRecom[0].cod_caen : 0,
                    caen_secundar: this.data.coduriCaenSecundare,
					cf2019: this.data.CA_2019 ? this.data.CA_2019 : 0,
					cf2020: this.data.CA_2020 ? this.data.CA_2020 : 0,
                    companii: '',
                    consultanti: '',
                    cofinantare: this.data2.cofinancing
                }
                if(this.data.CA_2019 && this.data.CA_2020){
                    this.caPercent = ((Number(this.data.CA_2019) - Number(this.data.CA_2020)) * 100 / Number(this.data.CA_2019)).toFixed(2);
                    if(!this.caPercent || this.caPercent < 0)
                        this.caPercent = 0;
                }
                if(this.data.CA_2020 === 0 || !this.data.CA_2020) {
                    this.caPercent = 100
                }
            }

            // RESCRIERE ELIGIBILITATE
           /* let bilant2019 = null
            if(this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length > 0){
                bilant2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
            }*/
			// let capital2019 = this.getCapital(2019);
            if(
                // !(bilant2019 && bilant2019[0] && bilant2019[0].profit_net > 0)
                !(this.termeneV3 && this.termeneV3.vechime > 2)
                // || !(this.data.CA_2020 && Number(this.data.CA_2020) > 0)
                || (this.data.CA_2020 > 250000000 && this.data.nr_angajati_2020 > 250)
                || !this.caMinim()
                || !this.caDifference()
				// || capital2019 < 0
            ) {
                this.body.eligibilitate = false
                this.header.eligibilitate = false
                this.data2.isEligible = false
            }

			if(this.data.CA_2020 === null && this.data.CA_2019 > 49460 && this.data.nr_angajati_2020 < 250 && this.termeneV3.vechime > 2) {
				this.eligibleCompany();
			}

            axios.get(api.API_ENDPOINTS.m3statusPopup).then(response => {
                this.dateModal.companii = response.data.companies
                this.dateModal.consultanti = response.data.m3sketch_consultants
                this.dateModal.solicitari = response.data.m3sketch_consultants_contacts
            })
            if(this.body.eligibilitate){
                setTimeout(() => {
                    this.modalShow = true
                }, 15000);
            }
            this.getInterogari();
            this.prepareModalData()

        },

        beforeDestroy () {
            // clear the timeout before the component is destroyed
            clearTimeout(this.timeout)
        },
        methods: {
            removeDiacritics (str) {
                for(var i=0; i<this.letters.length; i++) {
                    str = str.replace(this.letters[i].letters, this.letters[i].base);
                }
                return str;
            },
            setCofinance(event) {
                if(event && event > 0) {
                    this.dateModal.cofinantare = event
                }

            },
            caDifference() {
                let vechi = this.data.CA_2019
                let nou = this.data.CA_2020
                let difference = (vechi - nou) * 100 / vechi
                if(difference < 0) {
                    difference = 0
                }
                return difference >= 5;
            },
            calculateTotalScore(score) {
                if(score) {
                    let totalScore = 0
                    score.forEach(item => {
                        totalScore += item.value
                    })
                    this.data2.evaluation.score = totalScore
                    this.dateModal.punctaj = totalScore
                }
            },
            eligibleCompany() {
                this.body.eligibilitate = true;
                this.data2.isEligible = true;
                this.header.eligibilitate = true;
            },
            caenEligibil(isPrimary) {
                let eligibil
                if (isPrimary) {
                    eligibil = _.filter(listaCaen, v => v.caen === this.data.codCaenPrincipalRecom[0].cod_caen)
                } else {
                    let caenSecundare = _.map(this.data.coduriCaenSecundare, 'cod_caen_secundar')
                    eligibil = _.intersectionWith(listaCaen.map(v => v.caen), caenSecundare);
                }

                if (eligibil.length === 0) {
                    // Rosu
                    return 'neeligibil'
                } else if (eligibil[0].eligibil === "negativ") {
                    // Verde
                    return 'eligibil'
                } else if(eligibil[0].eligibil === 'pozitiv' || eligibil[0].eligibil === "necunoscut") {
                    return 'gri'
                }
            },
            secCaenEligibil() {
                let caenSecundare = _.map(this.data.coduriCaenSecundare, 'cod_caen_secundar')
                let find = _.filter(listaCaen, function(obj) {
                    if(caenSecundare.includes(obj.caen)){
                        return obj;
                    }
                })
                return find
            },
            addM3Company() {
                //            if(this.$store.state.auth.user.role === "Admin") {
                this.scrieLoading = true
                axios.get(api.API_ENDPOINTS.m3 + this.data2.cui).then(response => {
                    let vechi = this.data.CA_2019 ? this.data.CA_2019 : 0
                    let nou = this.data.CA_2020 ? this.data.CA_2020 : 0
                    let difference = (vechi - nou) * 100 / vechi
                    if(response.data.DateGenerale.cod_caen && response.data.DateGenerale.cod_caen.length === 3){
                        this.caenMain = '0'+response.data.DateGenerale.cod_caen
                    } else{
                        this.caenMain = response.data.DateGenerale.cod_caen
                    }
                    this.companyInfo = {
                        name: this.data2.nume,
                        business_id: this.data2.cui,
                        turnover_difference: parseFloat(difference).toFixed(2),
                        employees: this.data.nr_angajati_2020 ? this.data.nr_angajati_2020 : null,
                        reg_no: response.data.DateGenerale.cod_inmatriculare,
                        register_date: response && response.data && response.data.DateGenerale && response.data.DateGenerale.vechime_firma && response.data.DateGenerale.vechime_firma.data ? moment.utc(response.data.DateGenerale.vechime_firma.data, 'DD.MM.YYYY') : '',
                        main_caen: this.caenMain,
                        //business_type: this.data2,
                        imm_type: this.data2.enterpriseType,
                        address: response.data.DateGenerale.adresa_anaf,
                        //state: this.data2,
                        city: this.data.adresaRecom.localitate,
                        state: this.removeDiacritics(this.data.adresaRecom.judet),
                        street: this.data.adresaRecom.strada,
                        street_no: this.data.adresaRecom.numar,
                        bl: this.data.adresaRecom.bloc,
                        //bl_no: this.data2,
                        floor: this.data.adresaRecom.etaj,
                        apt: this.data.adresaRecom.apartament,
                        district: this.data.adresaRecom.sector,
                        //postal_code: this.data2,
                        phone: response.data.DateGenerale.telefon,
                        //email: this.data2,
                        //associates: this.data2,
                        //delegate: this.data2,
                        //delegate_type: this.data2,
                        vat_status: response.data.DateGenerale.statut_TVA,
                        evaluation: this.data2.evaluation.criteria.map(function (data) {
                            return data.value
                        }),
                        max_budget: this.finantareMaxim
                    }
                    this.prepareModalData();
                    if (this.$route.query.duplicate) {
                        this.companyInfo.duplicate = this.$route.query.duplicate;
                        this.companyInfo.sections = this.$route.query.sections;
                    }
                })
                    .finally(() => {
                        this.scrieLoading = false
                        if(this.data2.isEligible) {
                            this.sendCompanyToSketch()
                        } else {
                            let bilant2019 = null
                            if(this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length > 0){
                                bilant2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
                            }
                            this.dateNeeligibila = {
                                imm_type: this.companyInfo.imm_type,
                                vat_status: this.companyInfo.vat_status,
                                ca2019: this.data.CA_2019 ? this.data.CA_2019 : '',
                                ca2020: this.data.CA_2020 ? this.data.CA_2020 : '',
                                datainfiintare: this.termeneV3.vechime ? this.termeneV3.vechime : '',
                                pf2019: bilant2019 && bilant2019.length ? bilant2019[0].profit_net : 0
                            }
                            this.modalNeeligibil = true
                        /*this.$toast.error("Această companie nu este eligibilă. Ne pare rau! :(");*/
                        }
                    })

                //            } else {
                //                this.$toast.error('Încă lucrăm la această aplicație.');
                //            }
            },
            prepareModalData(){
                this.dateModal.finantareMaxim = this.finantareMaxim
                this.dateModal.cofinantare = ((this.data2.cofinancing / 100) * Number(this.dateModal.finantareMaxim)).toFixed(0)
                this.dateModal.m1 = this.help_moneyM1;
                this.dateModal.m2 = this.help_moneyM2;
                this.dateModal.horeca = this.help_moneyHoreca;
                this.dateModal.imm = this.termeneV3 && this.termeneV3.imminvest && this.termeneV3.imminvest.length ? this.termeneV3.imminvest[0].stare_solicitare : ''
                this.dateModal.statutTVA = this.termeneV3 ? this.termeneV3.statutTva : ''
                this.dateModal.angajati2020 = this.getEmployees(2020)
                this.dateModal.angajati2019 = this.getEmployees(2019)
                this.dateModal.capital2020 = this.getCapital(2020)
                this.dateModal.capital2019 = this.getCapital(2019)
            },
            getEmployees(year){
                let response = '-';
                if(this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length){
                    this.termeneV3.bilant_scurt.forEach(bilant => {
                        if(Number(bilant.an) === Number(year))
                            response = bilant.numar_mediu_angajati
                    })
                }
                return response;
            },
            getCapital(year){
                let response = '-';
                if(this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length){
                    this.termeneV3.bilant_scurt.forEach(bilant => {
                        if(Number(bilant.an) === Number(year))
                            response = bilant.capital_total
                    })
                }
                return response;
            },
            submitNeeligibleCompany(company) {
                this.checkMaxFinancing(company)
            },
            checkMaxAids() {
                let maxaids = 0
                if(this.help_moneyM1){
                    maxaids += this.help_moneyM1 / 4.8395
                }
                if(this.help_moneyM2){
                    maxaids += this.help_moneyM2 / 4.8395
                }
                if(this.help_moneyHoreca){
                    maxaids += this.help_moneyHoreca / 4.9260
                }
                return maxaids.toFixed(2)
            },
            checkStateAids() {
                let ajutorM1;
                let ajutorM2;
                let ajutorHoreca;
                if(this.data2 && this.data2.cui){
                    ajutorM1 = this.stateAids.m1
                    ajutorM2 = this.stateAids.m2
                    ajutorHoreca = this.stateAids.horeca
                }

                if(ajutorM1) {
                    if(ajutorM1['Status contract'] !== 'Respins'){
                        this.help_moneyM1 = '9679'
                    }
                    else {
                        this.help_moneyM1 = null
                    }
                }

                if(ajutorM2) {
                    if(ajutorM2['Status contract'] !== 'Contract respins' && ajutorM2['Status contract'] !== 'Respins in lista de asteptare' && ajutorM2['Status contract'] !== 'Respins In lista de asteptare'){
                        this.help_moneyM2 = ajutorM2['Suma solicitata']
                    }
                    else {
                        this.help_moneyM2 = null
                    }
                }
                if(ajutorHoreca) {
                    if(ajutorHoreca.Status === 'Aprobată'){
                        this.help_moneyHoreca = ajutorHoreca['Suma solicitata']
                    }
                    else {
                        this.help_moneyHoreca = null
                    }
                }
            },
            checkMaxFinancing(company) {
                this.checkStateAids()
                this.formSend = {
                    m1:  this.help_moneyM1 ?  (Number(this.help_moneyM1) / 4.8395).toFixed(0) : 0,
                    m2: this.help_moneyM2 ? (Number(this.help_moneyM2) / 4.8395).toFixed(0) : 0,
                    horeca: this.help_moneyHoreca ? (Number(this.help_moneyHoreca) / 4.9260).toFixed(0) : 0,
                    ca: (Number(company.ca2019) / 4.946).toFixed(0)
                }
                axios.post(api.API_ENDPOINTS.m3MaxBudget, this.formSend)
                    .then(response => {
                        this.companyInfo.turnover_difference = parseFloat(company.turnover_difference).toFixed(2)
                        this.companyInfo.evaluation[0] = company.turnover_points
                        this.companyInfo.turnover = company.ca2019
                        this.companyInfo.max_budget = Number(response.data.budget).toFixed(0)
                        this.sendCompanyToSketch()
                    })
            },
            sendCompanyToSketch() {
                axios.post(api.API_ENDPOINTS.m3company, this.companyInfo)
                    .then(response => {
                        this.$toast.success("Compania ta este eligibilă! Poți începe să scrii proiectul.");
                        if(response.data){
                            localStorage.setItem('currentM3Company', JSON.stringify(response.data.company))
                        }
                        this.$store.dispatch('checks/resetChecks')
                        this.$emit('newCompanyAdded', this.companyInfo.business_id)
                        this.$store.dispatch('m3Sketch/setM3Company', response.data.company)
                        this.$store.dispatch('m3Sketch/initializeAllData')
                        this.$store.dispatch('m3Sketch/initializeIndicators')
                        this.$store.dispatch('m3Sketch/initializeCompanies')
                        this.$router.push({name: 'M3Sketch'})
                    }).catch((xhr) => {
                        if (xhr.status === 422) {
                            this.errors.record(xhr.responseJSON.errors);
                        }
                        if(xhr && xhr.response && xhr.response.data && xhr.response.data.message)
                            this.$toast.error(xhr.response.data.message);
                    });
            },
            openConsultantModal() {
                this.prepareModalData()
                this.consultantShowModal = true
                this.modalShow = true
            },
            openCompanyModal() {
                this.companyModal = true
            },
            workingAt() {
                this.$toast.error('Încă lucrăm la această aplicație.');
                this.disabled = true
                this.timeout = setTimeout(() => {
                    this.disabled = false
                }, 3000)
            },
            getInterogari() {
                axios.get(api.API_ENDPOINTS.m3push)
                    .then(response => {
                        this.interogari = response.data.total;
                        this.interogariNoi = response.data.newTotal;
                        this.statistici = {
                            scores: Object.keys(response.data.scores).map(function(score) {
                                return score + ' pct';
                            }),
                            scoresValues: Object.values(response.data.scores),
                            turnoverKeys: response.data.turnover_difference.map(function(turnover) {
                                return turnover.percent;
                            }),
                            turnoverValues: response.data.turnover_difference.map(function(turnover) {
                                return turnover.total;
                            }),
                            eligibile: response.data.eligible,
                            neeligibile: response.data.newTotal - response.data.eligible,
                        }
                    })
            },
            caMinim() {
                let caMinim2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
                let cursEuro = 4.946
                if(caMinim2019[0]){
                    return (caMinim2019[0].cifra_de_afaceri_neta / cursEuro) >= 10000;
                }
            }
        }
    }
</script>

<style scoped>
.analiza-number{
    font-size: 14px;
    font-weight: 800;
}
.caen{
    font-size: 23px !important;
    color: #3b4369;
    font-weight: inherit;
    padding: 13px 0;
}
.eligibil{
    font-weight: 700 !important;
    color: #46cca6 !important;
}
.neeligibil{
    font-weight: 700 !important;
    color: #ff6767 !important;
}
.red-text{
    color: #ff6767 !important;
}
.green-text{
    color: #46cca6 !important;
}
.infoPoint{
    color: #01aef0;
}
.caen-principal, .ajutoare-stat{
    width: 29%;
}
.informatii-utile{
    width: 49%;
}
.bullet-bg-green, .bullet-bg-blue, .bullet-bg-red{
    display: block;
    border-radius: 50%;
    position: relative;
    width: 9px;
    height: 9px;
    margin-top: 2px;
}
.bullet-bg-green{
    background: #46cca6;
}
.bullet-bg-blue{
    background: #3b4369;
}
.bullet-bg-red{
    background: #ff6767;
}
.bullet{
    position: absolute;
    display: block;
    border-radius: 50%;
    background: #fff;
    width: 5px;
    height: 5px;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
}
.caen-status span{
    font-size: 10px;
    color: #3b4369;
}
.caen-status{
    margin: 15px 0;
}
.caen-principal ul{
    display: flex;
    max-height: 730px;
    overflow: auto;
    flex-wrap: wrap;
}
.caen-principal li{
    padding-right: 10px;
}
.caen-small{
    font-size: 16px;
    color: #3b4369;
    font-weight: inherit;
    padding: 13px 0;
}
.padding-box{
    padding: 15px;
    position: relative;
}
.modal-bottom{
    position: fixed;
    bottom: 0;
    left: 250px;
    width: calc( 100% - 250px);
    background: rgb(0 0 0 / 89%) !important;
    min-height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
}
.showing{
    min-height: 60px !important;
    max-height: 60px !important;
    transition: 0.4s;
    height: 100%;
}
.not-showing{
    max-height: 0 !important;
    min-height: 0 !important;
    overflow: hidden;
    transition: 0.4s;
}
.modal-bottom a:hover{
    text-decoration: none;
}
.modal-bottom img{
    max-height: 35px;
}
.number{
    font-size: 45px;
    font-weight: 500;
    background: -webkit-linear-gradient(#ce278f, #9b54d3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 1;
}
.info-sketch p{
    text-align: left;
    font-size: 15px;
    font-weight: 300;
    margin: 0;
    color: #fff;
    margin-left: 15px;
}
.white-border-button{
    color: #fff;
    font-size: 15px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 200px;
    min-height: 35px;
    border: 1px solid #fff;
    border-radius: 4px;
    cursor: pointer;
    transition: 0.3s;
}
.modal-bottom .buttons{
    width: 100%;
    max-width: 420px;
    align-items: center;
}
.button-purple{
    background: linear-gradient(to bottom, #ce278f, #9b54d3);
    color: #fff;
    font-size: 15px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 200px;
    min-height: 35px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: 0.3s;
}
.button-purple:hover {
    background: linear-gradient(to bottom, #9b54d3, #ce278f);
}
.white-border-button:hover {
    background: #fff;
    color: #000;
    transition: 0.3s;
}
@media (max-width: 1500px){
    .modal-bottom{
        left: 210px;
        width: calc( 100% - 210px);
    }
    .columnLg{
        flex-direction: column;
    }
    .analiza-comp, .eligibilitate-comp, .green-bar, .ajutoare-stat{
        width: 100%;
    }
    .eligibilitate-comp{
        margin-bottom: 0 !important;
        margin-top: 1rem;
    }
    .calcule-ajutoare{
        flex-wrap: nowrap !important;
    }
    .columnLg div {
        width: 100% !important;
    }
}
@media (max-width: 1600px){
    .modal-bottom .info-sketch p{
        max-width: 200px;
    }
    .modal-bottom .info-sketch{
        display: flex;
    }
}
@media (max-width: 1400px){
    .modal-bottom .info-sketch p{
        font-size: 13px;
    }
    .button-purple, .white-border-button{
        max-width: 180px;
        font-size: 12px;
    }
    .button-purple {
      margin-right: 7px;
    }
    .modal-bottom .buttons{
        max-width: 380px;
    }
}
.disabled{
    pointer-events: none;
}
h1{
    font-size: 23px;
    color: #3b4369;
    margin-top: 15px;
    margin-bottom: 30px;
    font-weight: inherit;
    line-height: 30px;
}
.bolder {
    font-weight: 700;
}
.white-box{
    background: #ffffff;
    padding: 15px;
}
.raport-result{
    max-width: 600px;
}
.buttons{
    width: 47%;
    max-width: 510px;
}
.write-button{
    background: #36ad8c;
    cursor: pointer;
}
.red-button{
    background: #FF6767;
    cursor: pointer;
}
.write-button span, .red-button span, .back-button span{
    font-size: 13px;
    color: #fff;
}
.write-button, .back-button, .red-button{
    border-radius: 3px;
    padding: 4px 25px;
    max-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.back-button{
    background: #0d0c4e;
    cursor: pointer;
}
.blue-box{
    background: #0d0c4e;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.green-bar{
    background: #76d6b9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    min-height: 60px;
    cursor: pointer;
    transition: 0.4s;
}
.green-bar img{
    max-height: 35px;
    filter: brightness(0) invert(1);
}
.green-bar:hover{
    background: #5fad95;
}
.green-bar h2{
    font-size: 23px;
    color: #fff;
    margin: 0;
}
.white-box p{
    font-size: 14px;
    color: #3b4369;
    max-width: 980px;
    line-height: 23px;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.fixed-height{
    height: 70%;
    align-items: center;
}
.m3-small{
    max-height: 45px;
}
.smallLogo{
    vertical-align: initial;
}
.grid-m3 {
    display: grid;
    grid-template-columns: 1fr 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr 60px 1fr;
    gap: 15px 15px;
    grid-auto-flow: row;
    grid-template-areas:
    "detalii-finantare detalii-finantare detalii-finantare punctaj punctaj punctaj punctaj punctaj punctaj"
    "detalii-finantare detalii-finantare detalii-finantare punctaj punctaj punctaj punctaj punctaj punctaj"
    "detalii-finantare detalii-finantare detalii-finantare punctaj punctaj punctaj punctaj punctaj punctaj"
    "dataghid dataghid dataghid cheltuieli-eligibile cheltuieli-eligibile cheltuieli-eligibile cheltuieli-eligibile cheltuieli-eligibile cheltuieli-eligibile"
    "dataghid dataghid dataghid cheltuieli-eligibile cheltuieli-eligibile cheltuieli-eligibile cheltuieli-eligibile cheltuieli-eligibile cheltuieli-eligibile"
    "incepe-gratuit incepe-gratuit incepe-gratuit firma-consultanta firma-consultanta firma-consultanta firma-consultanta firma-consultanta firma-consultanta"
    ". . . . . . . . .";
}

.detalii-finantare { grid-area: detalii-finantare; }

.punctaj { grid-area: punctaj; margin-top: 0!important; }

.dataghid { grid-area: dataghid; }

.cheltuieli-eligibile { grid-area: cheltuieli-eligibile; }

.incepe-gratuit { grid-area: incepe-gratuit; }

.firma-consultanta { grid-area: firma-consultanta; gap: 15px; }
.module-title{
    font-size: 14px;
    color: #3b4369;
    font-weight: 700;
}
.grid-m3 p{
    line-height: 20px;
}
.green {
    color: #59b395;
}
.paddingleft{
    padding-left: 45px;
}
.paddingright{
    padding-right: 45px;
}
.cheltuieli-box{
    width: 100%;
    margin-left: 15px;
}
.green-button{
    width: 100%;
    height: 100%;
}
.green-button{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    text-align: center;
    padding: 5px;
    font-weight: 600;
    cursor: pointer;
    color: #fff;
    background: linear-gradient(#9dd582, #6ac096);
    transition: 0.4s;
}
.green-button:hover{
    background: linear-gradient(#6ac096, #9dd582);
    transition: 0.4s;
}
.orange-button{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    text-align: center;
    padding: 5px;
    font-weight: inherit;
    cursor: pointer;
    color: #3b4369;
    background: linear-gradient(#faae7d, #f8c570);
    transition: 0.4s;
}
.orange-button:hover{
    background: linear-gradient(#f8c570, #faae7d);
    transition: 0.4s;
}
.yellow{
    color: #ffea00;
}
.item-a{
    width: 22%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.item-b{
    width: 22%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.item-b a{
    width: 100%;
    padding: 15px;
}
.item-b{
    padding: 0 !important;
}
.item-b p{
    text-align: center;
}
.item-c{
    width: 54%;
}
.interogari{
  width: 50%;
}
.interogari{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.interogari h2{
  margin-top: 20px;
  margin-bottom: 0;
  font-size: 50px;
  font-style: italic;
  color: #d1d1d1;
  font-weight: 800;
  line-height: 57px;
}
.interogari p{
  font-size: 12px;
  margin-top: 5px;
  color: #606060;
}
.proiectulTau{
  width: 32%;
}
.proiectulTauCharts{
  display: flex;
}
.background-title{
  border: 1px solid #e5e5e9;
  background: #f1f1f4;
  color: #3b4369;
  font-size: 12px;
  padding: 4px 3px;
  font-weight: 600;
}
.total-points{
  margin-top: -25px;
  font-size: 30px;
  font-weight: 800;
  color: #3b4369;
  text-align: center;
}

.calcule-ajutoare{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
}
.suma-ajutor{
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.suma-ajutor p{
    color: #46cca6 !important;
}

.first-box{
  width: 40%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
}
.second-box{
  width: 40%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
}
.punctaj{
  width: 37%;
}
.proiectulTauTitle{
    font-weight: 700;
    color: #5b607a;
}
.infoContainer{
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 5px;
}
.infoContainer img{
    max-height: 30px;
}
.infoDescription{
    color: #84889b;
    font-size: 12px;
    margin-top: 5px;
}
.infoLinks{
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
    margin-left: 10px;
    padding: 2px 10px;
    border-radius: 4px;
    max-height: 30px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 200px;
}
.govLinks{
    background-color: #004990;
}
.smisLinks{
    background-color: #5c659d;
}
.infoUtile{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}
.masura{
    padding: 15px 0;
    border-bottom: 1px solid #e5e5e5;
}
.masura-title{
    font-size: 12px !important;
    font-weight: 600;
    color: #434a6f;
}
.masura-desc{
    font-size: 12px !important;
    margin-top: -8px;
    color: #434a6f;
}
.masura-bani{
    margin-top: 15px;
    font-size: 12px !important;
}
.bani-primiti{
    margin-top: 15px;
    font-size: 17px !important;
}
@media (max-width: 1850px){
    .buttons{
        width: 45%;
    }
    .raport-result {
        max-width: 600px;
    }
}
@media (max-width: 1350px){
    .buttons{
        display: flex !important;
        width: 47%;
    }
    .flex{
        display: block;
    }
    .interogari{
      width: 100%;
      margin-bottom: 1rem;
    }
    .proiectulTau{
      width: 100%;
      margin-bottom: 1rem;
    }
    .punctaj, .caen-principal, .informatii-utile{
      width: 100%;
      margin-bottom: 1rem;
    }
}
@media (max-width: 1400px){
  .grid-m3{
    display: block;
  }
  .detalii-finantare, .punctaj, .dataghid, .cheltuieli-eligibile, .incepe-gratuit, .firma-consultanta, .item-a, .item-b, .item-c{
    margin-top: 1rem;
  }
  .item-a, .item-b, .item-c{
    width: 100%;
  }
  .white-box p{
    max-width: 100%;
  }
  .fixed-height{
    display: flex !important;
    justify-content: flex-start;
  }
  .fixed-height >>> .flex{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .fixed-height >>> .flex:first-child{
    margin-right: 3rem;
  }
  .paddingleft{
    padding-left: 0;
  }
  .fixed-height >>> img{
    min-height: 70px;
    object-fit: none;
  }
  .cheltuieli-box{
    margin-left: 0;
  }
  .padding-box{
    padding-bottom: 10px;
  }
}
@media (max-width: 1300px){
    .buttons{
        display: flex !important;
        width: 70%;
    }
}
@media (max-width: 900px){
    .buttons{
        display: flex !important;
        width: 100%;
    }
}
@media (max-width: 767px){
  .caen{
    font-size: 42px;
  }
  .company-name, .analiza-result {
    font-size: 16px;
  }
  .analiza-title {
    font-size: 12px;
  }
  .analiza-number {
    font-size: 18px;
  }
  .modal-bottom{
    left: 0;
    width: 100%;
  }
  .modal-bottom .sketch-logo,
  .modal-bottom .info-sketch{
    display: none;
  }
  .modal-bottom .buttons {
    margin: 0 auto;
  }
  .caen-principal {
    margin-bottom: 20px!important;
  }
  .interogari-eligibil {
    margin-bottom: 60px;
  }
  .caen-status {
    margin-left: 0px!important;
  }
  .infoContainer-outer {
    margin-right: 0!important;
  }
  .infoContainer {
    justify-content: space-between;
  }
}
@media (max-width: 600px){
    .green-bar{
        flex-direction: column;
    }
    .green-bar img{
        margin-top: 20px;
    }
    h1 {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 10px!important;
    }
  .green-bar h2{
    font-size: 18px;
  }
}
@media (max-width:420px){
  .upper-btns{
    flex-direction: column;
  }
  .upper-btns div {
    margin-bottom: 10px;
  }
  .calcule-ajutoare .suma-ajutor .total-title  {
    font-size: 12px;
  }
  .calcule-ajutoare .suma-ajutor .total-suma {
    font-size: 14px!important;
  }
  .infoLinks {
    height: 40px;
    max-height: 40px;
    padding: 5px 10px;
  }
  .termene-logo {
    margin-top: 10px!important;
  }
  .first-box,.second-box{
    width: 48%;
  }
  .first-box .proiectulTauTitle , .second-box .proiectulTauTitle {
    font-size: 11px;
    text-align: center;
  }
}
@media (max-width:370px){

  .calcule-ajutoare   {
    flex-direction: column;
  }
  .calcule-ajutoare .suma-ajutor {
    margin-bottom: 10px;
  }
  .calcule-ajutoare .suma-ajutor:last-of-type{
    margin-bottom: 0px;
  }
}

</style>
